import React from 'react';

import { OmitStrict, withCoreUIType } from '@tanium/coreui-utils';
import { NotificationBase, NotificationBaseProps } from '@tanium/react-notifications-base';

export const NOTIFICATION_COREUITYPE = 'Notification';

export interface Props extends OmitStrict<NotificationBaseProps, 'className' | 'style'> {}

/**
 * Notification to alert the user of useful information. If the information should not persist for
 * very long, consider using Toast Notifications with `useToastNotificationsControl`.
 */
const Notification = ({
  role,
  children,
  onDismiss,
  type,
  'data-test-id': testId,
  nestedProps = {},
}: Props) => (
  <NotificationBase
    onDismiss={onDismiss}
    type={type}
    data-test-id={testId}
    nestedProps={nestedProps}
    role={role}
  >
    {children}
  </NotificationBase>
);

export default withCoreUIType(NOTIFICATION_COREUITYPE)(Notification);
